import { Button as MuiButton, CircularProgress } from '@mui/material'
import type { ButtonProps as MuiButtonProps } from '@mui/material'

type ButtonProps = MuiButtonProps & {
    /** Replaces startIcon with a spinner and disables the button while true */
    loading?: boolean
}

const Button = ({ loading = false, disabled, startIcon, children, ...props }: ButtonProps) => (
    <MuiButton
        {...props}
        disabled={disabled || loading}
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : startIcon}
    >
        {children}
    </MuiButton>
)

export default Button
